import { IArtistResponse } from 'services/artists/types';
import { IMusicProductDigitalArtistForm } from 'services/music-product-digital/types/form';
import { ARTIST_ROLE, IArtistWithRoleForm } from 'services/types';

export const updateArtistsFromArtistResponse = (
  artistResponse: IArtistResponse,
  formArtists: IArtistWithRoleForm[],
): IArtistWithRoleForm[] => {
  const updatedArtists = formArtists.map((artist) => {
    if (artist.id === artistResponse.id) {
      return {
        id: artist.id,
        role: artist.role,
        nickname: artistResponse.nickname,
        previewPicture: artistResponse.profilePictureLink,
        artistStatus: artistResponse.artistStatus,
        isDuplicated: artist.isDuplicated,
        watchListArtist: artist.watchListArtist,
      };
    }
    return artist;
  });

  if (!updatedArtists.find((a) => a.id === artistResponse.id)) {
    return [
      ...updatedArtists,
      {
        id: artistResponse.id,
        role: ARTIST_ROLE.unknown,
        nickname: artistResponse.nickname,
        previewPicture: artistResponse.profilePictureLink,
        artistStatus: artistResponse.artistStatus,
        isDuplicated: false,
        watchListArtist: false,
      },
    ];
  }

  return updatedArtists;
};
